import type { MatchedRoute } from '../RoutingStore';

export const getActiveCategorySlug = (route: MatchedRoute | null, primaryCategorySlug: string): string | undefined => {
  if (!route) {
    return undefined;
  }

  if (route.routeName === 'home') {
    return primaryCategorySlug;
  }

  if (route.routeName === 'category' || route.routeName === 'subCategory') {
    return route.params.categorySlug;
  }

  return undefined;
};

export const getActiveSubCategorySlug = (route: MatchedRoute | null): string | undefined => {
  if (!route) {
    return undefined;
  }
  if (route.routeName === 'subCategory') {
    return route.params.subCategorySlug;
  }

  return undefined;
};
